import * as React from 'react';

export const useTemplateController = () => {
  const [emailSubject, setEmailSubject] = React.useState('');
  const [emailTemplate, setEmailTemplate] = React.useState('');

  return {
    emailSubject,
    emailTemplate,
    setEmailSubject,
    setEmailTemplate,
  };
};